// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class TempJanssenGeCheckDefaultResponse {
    static getAttributeTypeMap() {
        return TempJanssenGeCheckDefaultResponse.attributeTypeMap;
    }
}
TempJanssenGeCheckDefaultResponse.discriminator = undefined;
TempJanssenGeCheckDefaultResponse.additionalProperties = false;
TempJanssenGeCheckDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "JanssenGECheckResponseModel"
    },
];
//# sourceMappingURL=tempJanssenGeCheckDefaultResponse.js.map